import { useLocalReactionStore } from "designSystem/hooks";
import { C8Node } from "csi/typings";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { ErrorBoundary, useErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../component/ErrorFallback";
import AddChannel from "./component/AddChannel";
import ChannelSelection from "./component/ChannelSelection";
import ConnectToMSTeams from "./component/ConnectToMSTeams";
import DisplayChannel from "./component/DisplayChannel";
import JoinMSTeams from "./component/JoinMSTeams";
import { MSTeamsPanel, MSTeamsStore, MSTeamsStoreContext, useMSTeamsStore } from "./component/MSTeamsStore";

export interface MSTeamsForC8ObjectProps {
	/** context node */
	node?: C8Node;
}

export const MSTeamsForC8Object: FunctionComponent<MSTeamsForC8ObjectProps> = ({ node }) => {
	const store = useLocalReactionStore(() => new MSTeamsStore());

	return (
		<MSTeamsStoreContext.Provider value={store}>
			<ErrorBoundary
				FallbackComponent={ErrorFallback}
				onReset={store?.recover}
				resetKeys={[store?.currentPanel]}
			>
				{store &&
					<MSTeamsForC8ObjectInternal node={node} />
				}
			</ErrorBoundary>
		</MSTeamsStoreContext.Provider>
	);
};

const MSTeamsForC8ObjectInternal: FunctionComponent<MSTeamsForC8ObjectProps> = observer(({ node }) => {
	const { currentPanel, error } = useMSTeamsStore();
	const { showBoundary } = useErrorBoundary();


	if (error) {
		showBoundary(error);
	}

	switch (currentPanel) {
		case MSTeamsPanel.JOIN_MSTEAMS:
			return (<JoinMSTeams />);
		case MSTeamsPanel.CONNECT_TO_MSTEAMS:
			return (<ConnectToMSTeams />);
		case MSTeamsPanel.CHANNEL_SELECTION:
			return (<ChannelSelection />);
		case MSTeamsPanel.ADD_CHANNEL:
			return (<AddChannel />);
		case MSTeamsPanel.DISPLAY_CHANNEL:
			return (<DisplayChannel />);
	}
});

export default MSTeamsForC8Object;